// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section{
    margin-top: 80px;
 }
 .form-group{
    position: relative;
 }
 .form-control{
    /* width: 50%; */
    height: 52px;
    border-radius: 15px;
    border: 1px solid #215D88;
 }
 h1{
    font-size: 32px;
    color: #215D88;
    font-weight: 600;
 }
 .navbar-brand{
    background-color: #215D88;
    width: 25%;
    text-align: left;
    margin: 1rem 0;
 }
 p,span{
    color: #215D88;
 }
 i{
    font-size: 20px;
    color: #215D88;
 }
 button{
    border-radius: 13px;
    border: 1px solid #215D88;
    padding: 8px 12px; 
    background: #215D88 0% 0% no-repeat padding-box;
 }
 .radiobtn{
    justify-content: space-evenly;
 }
 .radiobtn label {
    display: block;
    background: white;
    border-radius: 13px;
    padding: 8px 28px;
    border: 1px solid #215D88;
    margin: 4px;
    cursor: pointer;
    font-size: 16px;
    box-shadow: 0px 4px 16px #215D8852;
    line-height: 1.75;
 }
 .radiobtn input[type="radio"]  {
    display: none;
    position: absolute;
    width: 100%;
    -webkit-appearance: none;
            appearance: none;
 }
 .radiobtn input[type="radio"]:checked + label {
    background: #215D88;
    animation-name: blink;
    animation-duration: 1s;
    border-color:#215D88;
    color: white;
    box-shadow: none;
 }
 .carousel-indicators li{
    background-color: #215D88 !important;
    width: 10px;
    height: 10px;
    border-radius: 100%;
 }
 .carousel-indicators{
    top: 90%;
 }
 i:focus{
    outline: none;
 }
 .w-90{
    width: 90%;
 }
 /* form{
    padding-left: 3rem;
 } */
 .resend{
    cursor: pointer;
    color: #215D88;
 }
 input[type="checkbox"] {
    height: 20px;
     width: 20px;
     vertical-align: super;
     position: relative;
     top: 10px;
 }
 .resend{
    border: none;
    background: white;
    font-weight: 500;
    opacity: .8;
 }
 .eye{
    position: absolute;
     /* top: 113px; */
     top: 16px;
     right: 32px;
 }
 .forgot{
    position: absolute;
    right: 0%;
    top: 25%;
    font-size: 17px;
 }
 .forgot:hover{
    text-decoration: underline;
    color: #215D88;
    cursor: pointer;
 }
 .validation label{
    font-size: 13px;
    padding-right: 0px !important;
 }
 @media screen and (max-width:768px){
    h1{
       font-size: 24px;
       text-align: center;
    }
    form{
       padding-left: 2px;
    }
    .navbar-brand{
       margin-top: 0;
       margin-bottom: 2rem;
    }
    .form-control{
       width: 100%;
       height: 45px;
    }
    .radiobtn label{
       padding: 4px 24px;
        text-align: center;
    }
    .eye{
       top: 11px;
       right: 20px;
    }
    .form-check-label{
       font-size: 14px;
    }
    .forgot{
       position: absolute;
     right: 0%;
     font-size: 14px;
     top: 16px;
    }
    .validation label{
       font-size: 12px;
    }
 }`, "",{"version":3,"sources":["webpack://./src/app/consultant-login/consultant-login.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;CACnB;CACA;IACG,kBAAkB;CACrB;CACA;IACG,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;CAC5B;CACA;IACG,eAAe;IACf,cAAc;IACd,gBAAgB;CACnB;CACA;IACG,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,cAAc;CACjB;CACA;IACG,cAAc;CACjB;CACA;IACG,eAAe;IACf,cAAc;CACjB;CACA;IACG,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,+CAA+C;CAClD;CACA;IACG,6BAA6B;CAChC;CACA;IACG,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,iBAAiB;CACpB;CACA;IACG,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,wBAAgB;YAAhB,gBAAgB;CACnB;CACA;IACG,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;CACnB;CACA;IACG,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,mBAAmB;CACtB;CACA;IACG,QAAQ;CACX;CACA;IACG,aAAa;CAChB;CACA;IACG,UAAU;CACb;CACA;;IAEG;CACH;IACG,eAAe;IACf,cAAc;CACjB;CACA;IACG,YAAY;KACX,WAAW;KACX,qBAAqB;KACrB,kBAAkB;KAClB,SAAS;CACb;CACA;IACG,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;CACd;CACA;IACG,kBAAkB;KACjB,gBAAgB;KAChB,SAAS;KACT,WAAW;CACf;CACA;IACG,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;CAClB;CACA;IACG,0BAA0B;IAC1B,cAAc;IACd,eAAe;CAClB;CACA;IACG,eAAe;IACf,6BAA6B;CAChC;CACA;IACG;OACG,eAAe;OACf,kBAAkB;IACrB;IACA;OACG,iBAAiB;IACpB;IACA;OACG,aAAa;OACb,mBAAmB;IACtB;IACA;OACG,WAAW;OACX,YAAY;IACf;IACA;OACG,iBAAiB;QAChB,kBAAkB;IACtB;IACA;OACG,SAAS;OACT,WAAW;IACd;IACA;OACG,eAAe;IAClB;IACA;OACG,kBAAkB;KACpB,SAAS;KACT,eAAe;KACf,SAAS;IACV;IACA;OACG,eAAe;IAClB;CACH","sourcesContent":["section{\n    margin-top: 80px;\n }\n .form-group{\n    position: relative;\n }\n .form-control{\n    /* width: 50%; */\n    height: 52px;\n    border-radius: 15px;\n    border: 1px solid #215D88;\n }\n h1{\n    font-size: 32px;\n    color: #215D88;\n    font-weight: 600;\n }\n .navbar-brand{\n    background-color: #215D88;\n    width: 25%;\n    text-align: left;\n    margin: 1rem 0;\n }\n p,span{\n    color: #215D88;\n }\n i{\n    font-size: 20px;\n    color: #215D88;\n }\n button{\n    border-radius: 13px;\n    border: 1px solid #215D88;\n    padding: 8px 12px; \n    background: #215D88 0% 0% no-repeat padding-box;\n }\n .radiobtn{\n    justify-content: space-evenly;\n }\n .radiobtn label {\n    display: block;\n    background: white;\n    border-radius: 13px;\n    padding: 8px 28px;\n    border: 1px solid #215D88;\n    margin: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    box-shadow: 0px 4px 16px #215D8852;\n    line-height: 1.75;\n }\n .radiobtn input[type=\"radio\"]  {\n    display: none;\n    position: absolute;\n    width: 100%;\n    appearance: none;\n }\n .radiobtn input[type=\"radio\"]:checked + label {\n    background: #215D88;\n    animation-name: blink;\n    animation-duration: 1s;\n    border-color:#215D88;\n    color: white;\n    box-shadow: none;\n }\n .carousel-indicators li{\n    background-color: #215D88 !important;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n }\n .carousel-indicators{\n    top: 90%;\n }\n i:focus{\n    outline: none;\n }\n .w-90{\n    width: 90%;\n }\n /* form{\n    padding-left: 3rem;\n } */\n .resend{\n    cursor: pointer;\n    color: #215D88;\n }\n input[type=\"checkbox\"] {\n    height: 20px;\n     width: 20px;\n     vertical-align: super;\n     position: relative;\n     top: 10px;\n }\n .resend{\n    border: none;\n    background: white;\n    font-weight: 500;\n    opacity: .8;\n }\n .eye{\n    position: absolute;\n     /* top: 113px; */\n     top: 16px;\n     right: 32px;\n }\n .forgot{\n    position: absolute;\n    right: 0%;\n    top: 25%;\n    font-size: 17px;\n }\n .forgot:hover{\n    text-decoration: underline;\n    color: #215D88;\n    cursor: pointer;\n }\n .validation label{\n    font-size: 13px;\n    padding-right: 0px !important;\n }\n @media screen and (max-width:768px){\n    h1{\n       font-size: 24px;\n       text-align: center;\n    }\n    form{\n       padding-left: 2px;\n    }\n    .navbar-brand{\n       margin-top: 0;\n       margin-bottom: 2rem;\n    }\n    .form-control{\n       width: 100%;\n       height: 45px;\n    }\n    .radiobtn label{\n       padding: 4px 24px;\n        text-align: center;\n    }\n    .eye{\n       top: 11px;\n       right: 20px;\n    }\n    .form-check-label{\n       font-size: 14px;\n    }\n    .forgot{\n       position: absolute;\n     right: 0%;\n     font-size: 14px;\n     top: 16px;\n    }\n    .validation label{\n       font-size: 12px;\n    }\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
